import { render, staticRenderFns } from "./UpdateDept.vue?vue&type=template&id=087b0bc7&scoped=true"
import script from "./UpdateDept.vue?vue&type=script&lang=js"
export * from "./UpdateDept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087b0bc7",
  null
  
)

export default component.exports